import apiFetch from '../apiFetch'

export default function (token, documentTypeUse) {
  return apiFetch({ endPoint: `DocumentTypeUse/${documentTypeUse.documentTypeUseId}`, method: 'PUT', body: documentTypeUse, token: token })
}
